import { TypeSortie } from "./type-sortie";
import { Users } from "./users";
import { Patients } from "./patients";

export class SortieDialyse {
  id: number;
  description: string;
  createdAt: any;
  updatedAt: any;
  dateSortie: any;
  createur: Users;
  typeSortie: TypeSortie;
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/sortie-dialyse.ts